import { render } from "./App.vue?vue&type=template&id=68c36560"
const script = {}

import "./App.vue?vue&type=style&index=0&id=68c36560&lang=scss"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.39_vue@3.5.39_typescript@6.0.3__webpack@5.108.0_esbuild@0.28.0_postcss@8.5.25_/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__